import produce from 'immer'
import { handleActions } from 'redux-actions'

import {
  CANCEL_COLI,
  CLEAR_ORDER,
  RECEIVE_CANCEL_COLI,
  RECEIVE_ORDER,
  REQUEST_ORDER,
} from './constants'

const initFilter = {
  page: 1,
  filter: [{ field: 'inactive', value: true }],
  sort: [
    {
      field: ['created_at'],
      direction: 'desc',
    },
  ],
}

const initialState = {
  isLoading: false,
  order: undefined,
}
const handleOrderRequest = produce((draft) => {
  draft.order = undefined
  draft.isLoading = true
  draft.error = undefined
})

const handleReceiveOrder = produce((draft, { payload: { result, error } }) => {
  if (error) {
    draft.error = error
  } else {
    draft.order = parseOrder(result)
  }
  draft.isLoading = false
})

const handleCancelColi = produce((draft) => {
  draft.isLoading = true
})

const handleClearOrder = produce((draft) => {
  draft.order = undefined
})

const handleReceiveCancel = produce((draft, { payload: { result, error } }) => {
  if (result === 'success') {
    requestOrder(draft.order.id)
  }

  draft.isLoading = false
})

export default handleActions(
  {
    [REQUEST_ORDER]: handleOrderRequest,
    [RECEIVE_ORDER]: handleReceiveOrder,
    [CANCEL_COLI]: handleCancelColi,
    [RECEIVE_CANCEL_COLI]: handleReceiveCancel,
    [CLEAR_ORDER]: handleClearOrder,
  },
  initialState,
)

export const parseOrder = (value) => {
  if (!value) return undefined
  return {
    ...value,
    receiver: {
      name1: value.receiverName1,
      name2: value.receiverName2,
      name3: value.receiverName3,
      street: value.receiverStreet,
      streetNumber: value.receiverStreetNumber,
      streetNumberAddition: value.receiverStreetNumberAddition,
      city: value.receiverCity,
      zip: value.receiverZip,
      country: value.receiverCountry,
    },
    sender: {
      name1: value.senderName1,
      name2: value.senderName2,
      name3: value.senderName3,
      street: value.senderStreet,
      streetNumber: value.senderStreetNumber,
      streetNumberAddition: value.senderStreetNumberAddition,
      city: value.senderCity,
      zip: value.senderZip,
      country: value.senderCountry,
    },
    invoice: {
      name1: value.invoiceName1,
      name2: value.invoiceName2,
      name3: value.invoiceName3,
      street: value.invoiceStreet,
      streetNumber: value.invoiceStreetNumber,
      streetNumberAddition: value.invoiceStreetNumberAddition,
      city: value.invoiceCity,
      zip: value.invoiceZip,
      country: value.invoiceCountry,
    },
    neutral: {
      name1: value.neutralSenderName1,
      name2: value.neutralSenderame2,
      name3: value.neutralSenderame3,
      street: value.neutralSenderStreet,
      streetNumber: value.neutralSenderStreetNumber,
      streetNumberAddition: value.neutralSenderStreetNumberAddition,
      city: value.neutralSenderity,
      zip: value.neutralSenderZip,
      country: value.neutralSenderCountry,
    },
  }
}
